import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query getSoftwareInfoByUser($id: String!, $page: Int!, $size: Int!) {
    softwareInfoByUser(id: $id, page: $page, size: $size) {
      content {
        order {
          softwareOrderId
          chassis
          vin
          modelYear
          vehicleType
          price
          userId
          orderNumber
          orderDate
          transactionId
        }
        download {
          swdlId
          softwareOrderId
          download
          price
          credit
          creditTax
        }
        userId
      }
      totalElements
      totalPages
    }
  }
`;

const useSoftwareInfoByUser = (userId: string, page: number, size: number) => {
  const { data, error, loading } = useQuery(QUERY, {
    variables: { id: userId, page, size },
  });

  if (error) {
    console.error(error);
    return null;
  }

  if (loading) {
    return null;
  }

  return data.softwareInfoByUser;
};

export default useSoftwareInfoByUser;
